export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Solutions', path: '/solutions' },
  { label: 'About Us', path: '/about-us' },
  { label: 'Sectors', path: '/sectors' },
  { label: 'Why Choose Us', path: '/why-choose-us' },
];